import * as TablerIcons from '@tabler/icons-react';

export function Icon({ name, size = 18, stroke = 1.5, className = '' }) {
  const Component = TablerIcons[name];
  if (!Component) return null;
  return <Component size={size} strokeWidth={stroke} className={className} />;
}
